module.exports = __webpack_public_path__ + "static/media/camions_animation.ce964851.gif";